import React from 'react';
import {Typography, Input} from 'antd';
import {Controller} from 'react-hook-form';
import { ColumnsType } from 'antd/es/table/InternalTable';
import FormModal, { FormModalProps } from './FormModal';
import Table from '../lists/Table/Table';
import ImageUploadInput from '../forms/utils/ImageUploadInput';


const MultipleTrafficDriversEditModal: React.FC<FormModalProps<any>> = (props) => {
  const editColumns: ColumnsType<{websites: {name: string}[]}> = [
    {
      key: "websites",
      title: "Websites",
      dataIndex: "websites",
      width: 200,
      render: (websites) => <Typography.Paragraph>{websites.map(({name}: {name: string}) => name).join(', ')}</Typography.Paragraph>
    },
    {
      key: "headline",
      title: "Headline",
      dataIndex: "headline",
      render: (_value, _record, index) =>
        <Controller
          name={`items.${index}.headline`}
          rules={{ required: true }}
          render={({ field }) => <Input.TextArea {...field} showCount maxLength={65} />}
        />
    },
    {
      key: "imageId",
      title: "Banner",
      dataIndex: "imageId",
      render: (_value, _record, index) => <ImageUploadInput name={`items.${index}.imageId`} />,
    },
  ]
  
  return (
    <FormModal
      width='70vw'
      {...props}
    >
      <Table
        searchable={false}
        columns={editColumns}
        data={props.defaultValues.items}
        scroll={{y: '50vh'}}
      />
    </FormModal>
  );
};

export default MultipleTrafficDriversEditModal;

